/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageResource } from '../../models/page-resource';

export interface ListExcels$Params {
}

export function listExcels(http: HttpClient, rootUrl: string, params?: ListExcels$Params, context?: HttpContext): Observable<StrictHttpResponse<PageResource>> {
  const rb = new RequestBuilder(rootUrl, listExcels.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageResource>;
    })
  );
}

listExcels.PATH = '/import/excels';
